import { makeHttpRequest } from "@/shared";

export const deletePoint = async (id) => {
    return (
        await makeHttpRequest({
            url: `/point/${id}`,
            method: "DELETE",
        })
    ).data;
};
